import { api } from "constants/RotasAPI";
import { LoadingContext } from "context/LoadingContext";
import { UserContext } from "context/UserContext";
import { useContext } from "react";
import { toast } from "react-hot-toast";
import { http } from "shared/util/http";
import IntegracaoV1 from "shared/util/integrarFrontEndV1Functions";
import { TokenDTO } from "types/dto/TokenDTO";

const usePostSetarContextoAdministradora = () => {
  const { redirectToV1 } = IntegracaoV1();
  const { alteraUsuarioContexto } = useContext(UserContext);
  const { setLoading } = useContext(LoadingContext);

  const setarContextoAdministradora = async () => {
    setLoading(true);
    await http
      .post<TokenDTO>(api.condominio.postSetarContextoAdministradora)
      .then((response) => {
        if (response.data && response.data.token) {
          localStorage.setItem("jhi-authenticationToken", response.data.token);
          alteraUsuarioContexto();
        }
        redirectToV1("/");
      })
      .catch((error) => toast.error("Erro ao alterar para contexto administradora"))
      .finally(() => setLoading(false));
  };

  return { setarContextoAdministradora };
};

export default usePostSetarContextoAdministradora;
